import { ReactNode } from "react";
import { Box } from '@mui/material';


const MapInfoPanel = ({ children }: { children?: ReactNode }) => {
  return (
    <Box
      sx={[
        (theme) => ({
          backgroundColor: theme.palette.background.default,
        }),
        {
          padding: 1,
          borderRadius: 1,
          boxShadow: '0 0 5px rgba(0,0,0,0.3)',
          width: 300
        }
      ]}
    >
      {children}
    </Box>
  )
};

export const MapInfoPanelControl = ({ children }: { children?: ReactNode }) => {
  return (
    <div className={'leaflet-top leaflet-right'}>
      <div className='leaflet-control'>
        <MapInfoPanel>
          {children}
        </MapInfoPanel>
      </div>
    </div>
  )
};

